import ENV from "react-dotenv";


import {
    LanguageInterface, CHANGE_LANGUAGE, CHANGE_LANGUAGE_ACTION_TYPE,
    LOCALIZATION_STATE_TYPE
} from "@Actions/Localization";


const {APP_NAME} = ENV || {};
const APP_ACTIVE_LANGUAGE_KEY = (APP_NAME || "") + "_APP_ACTIVE_LANGUAGE";


const storedActiveLanguage = localStorage.getItem(APP_ACTIVE_LANGUAGE_KEY);

const storedActiveLanguageObject: LanguageInterface =
    !!storedActiveLanguage ? JSON.parse(storedActiveLanguage) : {
        languageID: 1,
        languageCode: "PL"
    }
;


const LocalizationInitialState: LOCALIZATION_STATE_TYPE = {
    activeLanguage: storedActiveLanguageObject
};


type ACTION_TYPES = | CHANGE_LANGUAGE_ACTION_TYPE;



export const LocalizationReducer = (state = LocalizationInitialState, action: ACTION_TYPES) => {

    switch (action.type) {

        case CHANGE_LANGUAGE:
            localStorage.setItem(APP_ACTIVE_LANGUAGE_KEY, JSON.stringify(action.newLanguage));
            return {...state, activeLanguage: action.newLanguage};

        default:
            return state;

    }

};


export default LocalizationReducer;
